import { get, isEmpty } from 'lodash';

export const shouldShowBox = (expertise: any) => {
  const length =
    get(expertise, 'vehicules', []).length +
    get(expertise, 'victims', []).length;
  return length > 1 ? true : false;
};
export const getCurrentExpertise = (
  victimExpertises: any = [],
  vehiculeExpertises: any = [],
  itemId: any,
  expertiseId: any,
  expertiseJudgementAddDocumentId: any,
) => {
  const victimExpertise =
    victimExpertises.find(
      (el: any) =>
        Number(el.victimId) === Number(itemId) &&
        Number(expertiseId) === Number(el.expertiseId) &&
        Number(expertiseJudgementAddDocumentId) ===
          Number(el.expertiseJudgementAddDocumentId),
    ) || {};
  const vehicleExpertise =
    vehiculeExpertises.find(
      (el: any) =>
        Number(get(el, 'vehiculeId', '')) === Number(itemId) &&
        Number(expertiseId) === Number(get(el, 'expertiseId', '')) &&
        Number(expertiseJudgementAddDocumentId) ===
          Number(el.expertiseJudgementAddDocumentId),
    ) || {};
  return !isEmpty(victimExpertise) ? victimExpertise : vehicleExpertise;
};
